var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"welcome"},[_c('p',[_vm._v("页面未找到")]),_c('router-link',{attrs:{"to":"/","replace":""}},[_vm._v("回到首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }